var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"country-select",attrs:{"items":_vm.items,"color":"secondary","solo":"","item-text":"name","item-value":"abbr","prepend-icon":"mdi-truck","outlined":"","dense":"","hide-details":""},model:{value:(_vm.selectedCountry),callback:function ($$v) {_vm.selectedCountry=$$v},expression:"selectedCountry"}})
}
var staticRenderFns = []

export { render, staticRenderFns }